import {Form, FormInstance, Input, Modal} from "antd";
import React from "react";
import TextArea from "antd/es/input/TextArea";
import {AssetCategoryFormData} from "../type/asset-category.types";

interface CategoryModalProps {
    createCategoryModal: boolean;
    fetchAssetCateorgy: () => void;
    handleCategoryReset: () => void;
    handleAssetCategorySubmit: (values: AssetCategoryFormData) => Promise<void>;
    createAssetCategoryForm: FormInstance;
    editMode: boolean;
}

const CreateAssetModal = (props: CategoryModalProps) => {

    return (
        <Modal
            className={'hrms-app create-asset-modal'}
            title={props.editMode ? "Edit Asset Category" : "Create Asset Category"}
            open={props.createCategoryModal}
            onCancel={props.handleCategoryReset}
            onOk={async () => {
                try {
                    const values = await props.createAssetCategoryForm.validateFields();
                    await props.handleAssetCategorySubmit(values);
                } catch (error) {
                    console.log(error);
                }
            }}
        >
            <Form
                form={props.createAssetCategoryForm}
                layout="vertical"
            >
                <Form.Item
                    label={"Name"}
                    name={"name"}
                    rules={[
                        {required: true, message: "Please enter category name"}
                    ]}
                >
                    <Input placeholder={"Enter Name"}/>
                </Form.Item>
                <Form.Item
                    label={"Description"}
                    name={"description"}
                >
                    <TextArea placeholder={"Enter Description"}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CreateAssetModal;
